<template>
  <div id="app" :key="Date.parse(new Date())/1000">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

  data () {
    return{
      
    }
  },

  methods: {
  },

  mounted(){
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ./src/App.vue